module.exports = __webpack_public_path__ + "img/2B.3db20afc.jpg";